import { StyleSheet } from 'aphrodite';

const zooplusGreen = '#3C9700';

const stylesCommons = StyleSheet.create({
    content: {
        marginTop: '3rem',
        width: '90%',
        maxWidth: '90%',
        position: 'relative',
        left: '1%',
        textAlign: 'center',
        marginBottom: '10rem',
    },
    pointer: {
        cursor: 'pointer',
    },
    formContent: {
        marginTop: '3rem',
        width: '30%',
        maxWidth: '30%',
        position: 'relative',
        left: '30%',
        textAlign: 'center',
        marginBottom: '20rem',
    },
    headline: {
        color: zooplusGreen,
        lineHeight: '16px',
        fontWeight: 400,
        fontSize: '21px',
        backgroundColor: '#FFFFFF',
    },
    headlineSmall: {
        color: zooplusGreen,
        lineHeight: '16px',
        fontWeight: 400,
        fontSize: '18px',
        backgroundColor: '#FFFFFF',
    },
    input: {
        boxShadow: '0 4px 2px -2px gray',
    },
    inputWithPrefix: {
        ':nth-child(1n) > input': {
            flex: 1,
            width: 'inherit',
        },
    },
    dateFieldShort: {
        width: '70%',
        maxWidth: '70%',
        padding: 0,
        margin: 0,
        height: '2em',
        '> div': {
            height: '2.5em',
        },
    },
    filterDescription: {
        fontSize: '.9em',
    },
    buttonPrimary: {
        display: 'inline-block',
        color: '#FFF',
        backgroundImage: `linear-gradient(to right, ${zooplusGreen} , #66B100)`,
        backgroundColor: zooplusGreen,
        textAlign: 'center',
        ':hover': {
            backgroundImage: 'none',
            backgroundColor: zooplusGreen,
        },
        ':active': {
            backgroundColor: '#286400',
            backgroundImage: 'none',
        },
    },
    buttonSecondary: {
        display: 'inline-block',
        color: '#FFF',
        backgroundImage: 'linear-gradient(to right, #FF6200 , #FF8800)',
        backgroundColor: '#FF6200',
        textAlign: 'center',
        ':hover': {
            backgroundImage: 'none',
            backgroundColor: '#FF6200',
        },
        ':active': {
            backgroundColor: '#CC4E00',
            backgroundImage: 'none',
        },
    },
    dropdown: {
        backgroundColor: '#62A420',
    },
    table: {
        width: '25%',
        height: '25%',
    },
    link: {
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        color: zooplusGreen,
    },
    viewHeaderSecondary: {
        marginTop: '2rem',
        marginBottom: '2rem',
    },
    dropdownWide: {
        width: '100%',
    },
    divWithContentWidth: {
        display: 'inline-block',
    },
    copyableTextIcon: {
        cursor: 'pointer',
        textAlign: 'right',
    },
    fieldError: {
        background: '#fff6f6 !important',
        borderColor: '#e0b4b4 !important',
        color: '#9f3a38 !important',
    },
    fieldLabel: {
        fontWeight: 700,
    },
    fieldLabelRequired: {
        ':after': {
            margin: '-.2em 0 0 .2em',
            content: "'*'",
            color: '#db2828',
        },
    },
    noSpinners: {
        '-moz-appearance': 'textfield',
        '::-webkit-outer-spin-button,::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
    },
});

export default stylesCommons;
